import { IKeyValue } from 'shared/utils';

export interface IListagemOrgFornecedora {

    IdCanal: number,
    Canal: string,
    IdFornecedora: number,
    Fornecedora: string,
    IdOrganizacao: number,
    Organizacao: string,
    CodigoNomeOrganizacao: string,
    Prioridade: number,
    UsuariodeConexao: string,
    Senha: string,
    IdUsuarioInclusao: number,
    NomeUsuarioInclusao: string,
    DataInclusao: Date,
    UsuarioIdUpd: number,
    UsuarioNomeUpd: string,
    Status: string,
    TenantIddeConexao: string,
    CdScoreAtivos: string,
    NmScoreAtivos: string,
    CdScoreInativos: string,
    NmScoreInativos: string,
    EmailRemetente: string,
    NomeRemetente: string,
    EmailReply: string,
    ROW_NUM: number
}

export interface IResponseOrgFornecedora {

    count: number;
    rows: IListagemOrgFornecedora[];

}

export interface IListagemOrgFornecedoraLog {
    IdCanal: number,
    Canal: string,
    IdFornecedora: number,
    Fornecedora: string,
    IdOrganizacao: number,
    Organizacao: string,
    CodigoNomeOrganizacao: string,
    Prioridade: number,
    Usuario: string,
    Senha: string                                                                                                                                                                                                                                                   ,
    Operacao: string,
    NomeUsuarioInclusao: string,
    IdUsuarioInclusao: number,
    DataInclusao: Date,
    Status: string,
    TenantIddeConexao: string,
    CdScoreAtivos:string,
    NmScoreAtivos:number ,
    CdScoreInativos:string,
    NmScoreInativos:number ,
    EmailRemetente: string,
    NomeRemetente:string ,
    EmailReply: string,
    ROW_NUM: number
}

export interface IResponseOrgFornecedoralog {

    count: number;
    rows: IListagemOrgFornecedoraLog[];

}

export interface IDetalheOrgFornecedora {
    IdFornecedora: number,
    IdOrganizacao: number,
    IdCanal: number,
    Fornecedora: string,
    Organizacao: string,
    Canal: string,
    Prioridade: number,
    UsuariodeConexao: string,
    Senha: number,
    IdUsuarioInclusao: number,
    NomeUsuarioInclusao: string,
    DataInclusao: Date,
    UsuarioIdUpd: number,
    UsuarioNomeUpd: string,
    DhUpd: Date,
    Status: string,
    TenantIddeConexao: string,
    CdScoreAtivos: string,
    NmScoreAtivos: string,
    CdScoreInativos: string,
    NmScoreInativos: string,
    EmailRemetente: string,
    NomeRemetente: string,
    EmailReply: string
}

export interface IResponseDetalheOrgFornecedora {

    count: number;
    retorno: IDetalheOrgFornecedora[];

}

export interface IUpdateStatus{
    idFornecedora?: number,
    status?: string,
    idCanal?: number,
}

export interface ICreateOrgFornecedora {
    IdFornecedora?: number,
    Prioridade?: number,
    UsuariodeConexao?: string,
    Senha?: string,
    ConfirmarSenha?: string,
    DataInclusao?: Date,
    Status?: string,
    TenantIddeConexao?: string,
    CdScoreAtivos?: string,
    NmScoreAtivos?: string,
    CdScoreInativos?: string,
    NmScoreInativos?: string,
    EmailRemetente?: string,
    NomeRemetente?: string,
    EmailReply?: string
}

export const InicitalCreateOrgFornecedora = {
  IdFornecedora: 0,
  IdOrganizacao: 0,
  Prioridade: 0,
  Senha: '',
  UsuariodeConexao: '',
  TenantIddeConexao: '',
  CdScoreInativos: '>=0',
  NmScoreInativos: 'NÃO ENGAJADOS',
  CdScoreAtivos: '>=0',
  NmScoreAtivos: 'ENGAJADOS',
  Status: 'I',
  DataInclusao: new Date(),
  Organizacao: '',
  Canal: '',
  Fornecedora: '',
  IdCanal: 0,
  EmailRemetente: '',
  NomeRemetente: '',
  EmailReply: ''

};


export const listKeyValueStatusOrgForn: IKeyValue[] = [
  {
    key: 'A',
    value: 'Ativo'
  }, {
    key: 'I',
    value: 'Inativo'
  }];